"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
/* Blast Imports */
var constants_1 = require("@app/shared/constants");
var constants_2 = require("@server/shared/constants");
// tslint:disable:max-line-length
exports.Config = {
    /**
     * Url to the API
     */
    UI_SERVICES_URL: process.env.UI_SERVICES_URL,
    /**
     * Max total package size for pluginless uploads and downloads (in mb)
     */
    HTTP_TRANSFER_MAX_PACKAGE_SIZE: 1024,
    /**
     * How often to refresh pending packages (in ms)
     */
    PENDING_PACKAGES_REFRESH_INTERVAL: 5000,
    /**
     * How far back to go when viewing recently sent packages
     */
    PENDING_PACKAGES_HISTORY_LIMIT_IN_HOURS: 48,
    /**
     * How far back to go when viewing recently received package transfers
     */
    RECEIVED_PACKAGES_HISTORY_LIMIT_IN_HOURS: 24,
    PACKAGE_EXPIRE_LIMIT_IN_DAYS: 21,
    /**
     * Expression used to determine if a string is a valid email format
     */
    EMAIL_REGEX: constants_2.EMAIL_REGEX,
    /**
     * Expression used to determine if a user is internal or external
     */
    VALIDATE_EMAIL_REGEX: constants_2.VALIDATE_EMAIL_REGEX,
    /**
     * How long to hide the Aspera warning/banner once a user has dismissed it
     */
    ASPERA_BANNER_TIMEOUT_IN_DAYS: 30,
    /**
     * Contact email
     */
    CONTACT_EMAIL: 'Blast@hasbro.com',
    /**
     * Default page size for server-side pagination
     */
    DEFAULT_PAGE_SIZE: 20,
    /**
     * How often to poll the transfer state when performing an http pluginless download
     */
    PLUGINLESS_DOWNLOAD_POLLING_INTERVAL_IN_MS: 4000,
    PERIODICITY: constants_1.PERIODICITY,
    SESSION_TIME_COUNTDOWN: constants_1.SESSION_TIME_COUNTDOWN,
    ACTIVITY_OFFSET: constants_1.ACTIVITY_OFFSET,
    REFRESH_PACKAGE_CACHE_INTERVAL: constants_1.REFRESH_PACKAGE_CACHE_INTERVAL,
    FASPEX_CLIENT_BLAST: constants_2.FASPEX_CLIENT_BLAST
};
